<template>
    <div>
        <b-row>
            <b-col>
                <h2>Договор онл@йн</h2>
                <p>Пошаговая онлайн-форма заявки на заключение договора обращения с ТКО 
                <br/>для юридических лиц, индивидуальных предпринимателей.</p>
                <hr />
                <p><b>Обратите внимание</b>, для успешного завершения процедуры подачи заявки 
                <br/>вам понадобятся следующие документы в сканированном (или фото) виде:
                <br/>
                </p>
                <template v-if="fileslist.length === 0">
                    <b-spinner type="grow" variant="success"/>
                </template>
                <div v-if="fileslist.length > 0">
                    <template v-for="(item, index) of fileslist">
                        <span :key="index"><br/> {{ index + 1}}. {{ item.title }} 
                            <a v-if="item.link != null" :href="item.link" target="blank">(подробнее)</a>
                            <b class="text-danger" v-if="item.require === true"> * </b>
                        </span>
                    </template>
                    <br/><b class="text-danger"> * </b> - обязатальеные документы
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col offset-md="8" cols="4">
                <b-button block @click="$router.push('start')" variant="success">Начать</b-button>
            </b-col>
        </b-row>
        <eco-basement />
    </div>
    
</template>

<script>

export default {
    data() {
        return {
        }
    },
    computed: {
        fileslist() {
            return this.$store.getters.FILESLIST
        }
    }
    
}
</script>